import React, { useMemo } from 'react';
import { DatePicker, Input, Button, FallbackImage } from 'components';
import { WhiteImage } from 'assets/img';
import { Globals } from 'utils';
import { ContactCallIcon, ContactMessageIcon, ContactVideoCallIcon } from 'assets/icons';
import VideoRoom from '../ads/requests/video/video-room';
import { useTeleconsultations } from './use-teleconsultations';

const MODAL = {
  NONE: 0,
  VIDEO_ROOM: 1,
};

export default function TeleconsultationsWeb() {
  const {
    filters,
    modal,
    onChangeFilters,
    onAccept,
    onReject,
    onFinish,
    onCall,
    onChat,
    onVideoCall,
    selectedItem,
    setModal,
    videoRoomToken,
    solicitudes,
    historial,
    getData,
    canResetFilters,
    onResetFilters,
  } = useTeleconsultations();

  return (
    <main id="teleconsultations-web" style={{ backgroundColor: '#F8F9FA', minHeight: '100vh', padding: '20px' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <style>{`
        .tele-filters {
          display: flex;
          gap: 15px;
          align-items: center; 
          margin-bottom: 30px;
          flex-wrap: wrap;
        }
        
        .tele-filters > div:not(.tele-filter-buttons) {
          flex: 1;
          min-width: 200px;
          margin-bottom: 0 !important; /* Clave para que no se suban */
        }

        .tele-filter-buttons {
          display: flex;
          gap: 10px;
          align-items: center;
        }

        .tele-btn-apply {
          background-color: #75853B !important;
          color: white !important;
          border-radius: 25px !important;
          padding: 0 30px !important;
          height: 48px !important; /* Misma altura que los inputs */
          border: none;
          font-weight: bold;
          min-width: 120px;
          cursor: pointer;
        }

        .tele-btn-clear {
          background-color: #FFFFFF !important;
          color: #75853B !important;
          border: 1px solid #75853B !important;
          border-radius: 25px !important;
          padding: 0 30px !important;
          height: 48px !important;
          font-weight: bold;
          min-width: 120px;
          cursor: pointer;
          transition: background-color 0.2s;
        }
        .tele-btn-clear:hover {
          background-color: #F8F9FA !important;
        }

        .tele-section {
          background-color: white;
          border-radius: 20px;
          padding: 25px;
          margin-bottom: 30px;
          box-shadow: 0 4px 10px rgba(0,0,0,0.03);
        }
        .tele-section h3 {
          font-size: 20px;
          font-weight: 700;
          color: #333;
          margin-bottom: 20px;
          margin-top: 0;
        }
        .tele-empty {
          color: #999;
          font-style: italic;
        }
        
        .tele-card {
          display: grid;
          grid-template-columns: 2.5fr 3.5fr 2fr 3.5fr; 
          align-items: center;
          gap: 20px;
          padding: 20px;
          border: 1px solid #EAEAEA;
          border-radius: 12px;
          margin-bottom: 15px;
        }
        @media (max-width: 900px) {
          .tele-card {
            grid-template-columns: 1fr;
            gap: 15px;
          }
        }

        .tele-user {
          display: flex;
          align-items: center;
          gap: 15px;
        }
        .tele-avatar {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid #FFC857;
        }
        .tele-user-info h4 {
          margin: 0 0 5px 0;
          font-size: 16px;
          font-weight: 700;
          color: #333;
        }
        .tele-pill {
          display: inline-block;
          padding: 3px 10px;
          border-radius: 10px;
          font-size: 11px;
          font-weight: bold;
        }
        .pill-pending { background-color: #FEF3C7; color: #D97706; }
        .pill-approved { background-color: #D1FAE5; color: #059669; }
        .pill-rejected { background-color: #FEE2E2; color: #DC2626; }
        .pill-completed { background-color: #E5E7EB; color: #4B5563; }
        
        .pill-approved-clickable {
          cursor: pointer;
          border: none;
          transition: transform 0.1s;
        }
        .pill-approved-clickable:hover {
          transform: scale(1.05);
        }

        .tele-col-title {
          font-size: 12px;
          font-weight: 700;
          color: #333;
          margin: 0 0 5px 0;
        }
        .tele-col-text {
          font-size: 13px;
          color: #666;
          margin: 0;
          line-height: 1.4;
        }
        .tele-motive-emergency {
          color: #DC2626;
          font-weight: bold;
        }
        
        .tele-price {
          font-size: 20px;
          font-weight: bold;
          color: #333;
        }

        .tele-actions {
          display: flex;
          gap: 10px;
          justify-content: flex-end;
          align-items: center;
        }

        .tele-btn-reject {
          background-color: #DC2626;
          color: white;
          border: none;
          padding: 6px 12px;
          border-radius: 6px;
          font-weight: bold;
          font-size: 11px;
          cursor: pointer;
          transition: background-color 0.2s;
        }
        .tele-btn-reject:hover { background-color: #b91c1c; }

        .tele-btn-accept {
          background-color: #75853B;
          color: white;
          border: none;
          padding: 6px 12px;
          border-radius: 6px;
          font-weight: bold;
          font-size: 11px;
          cursor: pointer;
          transition: background-color 0.2s;
        }
        .tele-btn-accept:hover { background-color: #5d6a2f; }

        .tele-contact-icons {
          display: flex;
          gap: 10px;
          align-items: center;
        }
        .tele-icon-btn {
          background: transparent;
          border: none;
          padding: 0;
          cursor: pointer;
          transition: opacity 0.2s, transform 0.1s;
        }
        .tele-icon-btn img {
          width: 24px;
          height: 24px;
          object-fit: contain;
        }
        .tele-icon-btn:hover:not(:disabled) {
          transform: scale(1.1);
        }
        .tele-icon-btn:disabled {
          opacity: 0.3;
          cursor: not-allowed;
        }
      `}</style>

        {/* Modal de Videollamada */}
        {(modal === MODAL.VIDEO_ROOM && videoRoomToken && selectedItem.video_room_url) && (
          <VideoRoom
            origin="teleconsultation"
            consultation={selectedItem}
            token={videoRoomToken}
            onFinish={onFinish}
            onClose={() => setModal(MODAL.NONE)}
          />
        )}

        {/* BARRA DE FILTROS */}
        <div className="tele-filters">
          <Input
            name="search"
            placeholder="Nombre del cliente"
            value={filters.search}
            onChange={(e: any) => onChangeFilters(e.target.value, 'search')}
          />
          <DatePicker
            placeholder="Desde"
            value={filters.since}
            onChange={(v: string) => onChangeFilters(v, 'since')}
          />
          <DatePicker
            placeholder="Hasta"
            value={filters.until}
            onChange={(v: string) => onChangeFilters(v, 'until')}
          />

          {/* NUEVO CONTENEDOR PARA LOS BOTONES */}
          <div className="tele-filter-buttons">
            {canResetFilters && (
              <Button className="tele-btn-clear" onClick={onResetFilters}>
                Limpiar
              </Button>
            )}
            <Button className="tele-btn-apply" onClick={getData}>
              Aplicar
            </Button>
          </div>
        </div>

        <section className="tele-section">
          <h3>Solicitudes</h3>
          {solicitudes.length === 0 ? (
            <p className="tele-empty">No hay solicitudes pendientes o aprobadas.</p>
          ) : (
            solicitudes.map((item: any) => (
              <ConsultationCard
                key={item.id}
                item={item}
                tab="solicitudes"
                onAccept={onAccept}
                onReject={onReject}
                onFinish={onFinish}
                onVideoCall={onVideoCall}
                onCall={onCall}
                onChat={onChat}
              />
            ))
          )}
        </section>

        <section className="tele-section">
          <h3>Historial</h3>
          {historial.length === 0 ? (
            <p className="tele-empty">No hay registros en el historial.</p>
          ) : (
            historial.map((item: any) => (
              <ConsultationCard
                key={item.id}
                item={item}
                tab="historial"
              />
            ))
          )}
        </section>
      </div>
    </main>
  );
}

const ConsultationCard = ({ item, tab, onAccept, onReject, onFinish, onVideoCall, onCall, onChat }: any) => {

  const formattedDate = item.date ? item.date.split('-').reverse().join('-') : 'N/A';

  const isEmergency = item.is_emergency === 1;
  const isPendingPayment = item.status_payment === 0 || item.status_payment === 2;

  const formatTime12Hour = (timeStr: string) => {
    if (!timeStr) return 'N/A';
    if (timeStr.toLowerCase().includes('am') || timeStr.toLowerCase().includes('pm')) {
      return timeStr.toUpperCase();
    }
    const parts = timeStr.split(':');
    if (parts.length < 2) return timeStr;
    let hours = parseInt(parts[0], 10);
    const minutes = parts[1].substring(0, 2);
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    const strHours = hours < 10 ? '0' + hours : hours;
    return `${strHours}:${minutes} ${ampm}`;
  };

  const renderStatus = () => {
    switch (item.status) {
      case 0: return <span className="tele-pill pill-pending">Pendiente</span>;
      case 1: return (
        <button
          className="tele-pill pill-approved pill-approved-clickable"
          onClick={() => onFinish?.(item)}
          title="Haz clic para culminar la consulta"
        >
          Aprobada
        </button>
      );
      case 2: return <span className="tele-pill pill-rejected">Rechazada</span>;
      case 3: return <span className="tele-pill pill-completed">Culminada</span>;
      default: return null;
    }
  };

  const displayPrice = useMemo(() => {
    if (item.amount) return `$${Number(item.amount).toFixed(2)}`;
    if (item.consultation?.teleconsultation_rate?.amount) {
      return `$${Number(item.consultation.teleconsultation_rate.amount).toFixed(2)}`;
    }
    return '$0.00';
  }, [item]);

  const renderStars = () => {
    const rating = item.rating || 0;
    return (
      <div style={{ color: '#FFC857', fontSize: '14px', marginTop: '3px' }}>
        {[1, 2, 3, 4, 5].map((star) => (
          <span key={star}>{star <= rating ? '★' : '☆'}</span>
        ))}
      </div>
    );
  };

  return (
    <article className="tele-card">

      <div className="tele-user">
        <FallbackImage
          src={item.client?.photo ? Globals.fromPhotos(item.client.photo) : WhiteImage}
          placeholder={WhiteImage}
          className="tele-avatar"
          placeholderClassName="tele-avatar"
          alt={item.client?.name}
        />
        <div className="tele-user-info">
          <h4>{item.client?.name || 'Usuario'}</h4>
          {renderStatus()}
          {tab === 'historial' && item.status === 3 && renderStars()}
        </div>
      </div>

      {/* 2. Motivo */}
      <div>
        <p className="tele-col-title">Motivo</p>
        <p className={`tele-col-text ${isEmergency ? 'tele-motive-emergency' : ''}`}>
          {item.motive || 'Sin motivo especificado'}
        </p>
      </div>

      {/* 3. Fecha / Hora */}
      <div>
        <p className="tele-col-text" style={{ marginBottom: '5px' }}>
          <span style={{ color: '#999', marginRight: '5px' }}>📅 Fecha</span>
          <strong>{formattedDate}</strong>
        </p>
        <p className="tele-col-text">
          <span style={{ color: '#999', marginRight: '5px' }}>⏰ Hora</span>
          <strong>{formatTime12Hour(item.hour)}</strong>
        </p>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
        {tab === 'historial' && (
          <div style={{ flex: 1, paddingRight: '15px' }}>
            <p className="tele-col-title">Comentario</p>
            <p className="tele-col-text">{item.comments || 'Sin comentario'}</p>
          </div>
        )}
        <span className="tele-price">{displayPrice}</span>
        {tab === 'solicitudes' && (
          <div className="tele-actions">
            {item.status === 0 && (
              <>
                <button className="tele-btn-reject" onClick={() => onReject(item)}>RECHAZAR</button>
                <button className="tele-btn-accept" onClick={() => onAccept(item)}>ACEPTAR</button>
              </>
            )}
            {item.status === 1 && (
              <div className="tele-contact-icons">
                {isEmergency ? (
                  <>
                    <button disabled={isPendingPayment} className="tele-icon-btn" onClick={() => onVideoCall?.(item)}>
                      <img src={ContactVideoCallIcon} alt="Videollamada" title="Videollamada" />
                    </button>
                    <button disabled={isPendingPayment} className="tele-icon-btn" onClick={() => onCall?.(item)}>
                      <img src={ContactCallIcon} alt="Llamada" title="Llamada" />
                    </button>
                  </>
                ) : (
                  <>
                    {item.contact_method === 1 && (
                      <button disabled={isPendingPayment} className="tele-icon-btn" onClick={() => onVideoCall?.(item)}>
                        <img src={ContactVideoCallIcon} alt="Videollamada" title="Videollamada" />
                      </button>
                    )}
                    {item.contact_method === 2 && (
                      <button disabled={isPendingPayment} className="tele-icon-btn" onClick={() => onCall?.(item)}>
                        <img src={ContactCallIcon} alt="Llamada" title="Llamada" />
                      </button>
                    )}
                    {item.contact_method === 3 && (
                      <button disabled={isPendingPayment} className="tele-icon-btn" onClick={() => onChat?.(item)}>
                        <img src={ContactMessageIcon} alt="Chat" title="Chat" />
                      </button>
                    )}
                  </>
                )}
              </div>
            )}
          </div>
        )}
      </div>

    </article>
  );
};